import React, { useCallback, useEffect, useState } from "react";
import { Button } from "./StyledElements";
import {
  ReactFlow,
  applyEdgeChanges,
  applyNodeChanges,
  Controls,
  Background,
} from "@xyflow/react";
import "@xyflow/react/dist/style.css";
import { Node } from "../nodes/Node";
import { InputDocumentNode, TextSplittingNode, TextSplittingNodeCard, TransformTextNode, TransformTextNodeCard } from "../nodes";


const Workflow = ({ workflow, defaultNodes = [], filterNodes = null, onClose = () => { } }) => {
  console.log("!!! HERE IN WORFLOW COMPONENT, WORKFLOW: ", workflow);
  const nodeTypes = {
    defaultNode: Node,
    inputDocumentNode: InputDocumentNode,
    textSplittingNode: TextSplittingNode,
    transformTextNode: TransformTextNode,
  };

  const nodeTypeCards = {
    textSplittingNode: TextSplittingNodeCard,
    transformTextNode: TransformTextNodeCard,
  };

  const [nodes, setNodes] = useState([
    {
      id: "1",
      position: { x: 50, y: (window.innerHeight / 2) - 150 },
      data: { label: "Input Document" },
      type: "inputDocumentNode",
    }
  ]);
  const [edges, setEdges] = useState([]);

  useEffect(() => {
    if (workflow) {
      console.log("!!! WORKFLOW: ", workflow);
      const newNodes = [];
      const graphNodes = Object.values(workflow.graph.nodes);
      if (graphNodes) {
        graphNodes.forEach((node) => {
          newNodes.push({
            id: node.graph_id,
            position: { x: node.x / 2, y: node.y / 2 },
            data: { label: node.name },
          });
        });
      }
      setNodes(newNodes);

      const newEdges = [];
      const graphEdges = Object.values(workflow.graph.edges);
      if (graphEdges) {
        graphEdges.forEach((edge, index) => {
          console.log("!!! EDGE: ", edge);
          newEdges.push({
            id: index,
            source: edge.output.graph_id,
            target: edge.input.graph_id,
            label: edge.output.key,
            type: "straight",
          });
        });
      }

      console.log("!!! EDGES: ", newEdges);
      setEdges(newEdges);
    }
    // eslint-disable-next-line
  }, []);

  const onNodesChange = useCallback(
    (changes) => setNodes((nds) => applyNodeChanges(changes, nds)),
    []
  );

  const onNodesDelete = useCallback((nodes) => {
    console.log("!!! DELETE NODES: ", nodes);
    setNodes((nds) => nds.filter((n) => !nodes.includes(n.id)));
    setEdges((eds) => eds.filter((e) => !nodes.includes(e.source) && !nodes.includes(e.target)));
  }, []);

  const onEdgesChange = useCallback(
    (changes) => {
      console.log("!!! EDGE CHANGES: ", changes);
      setEdges((eds) => applyEdgeChanges(changes, eds));
    },
    []
  );

  const onConnect = useCallback(
    (params) => {
      console.log("!!! CONNECT PARAMS: ", params);
      console.log("EDGES BEFORE: ", edges);

      const edgeID = `edge-${params.source}-${params.sourceHandle}-to-${params.target}`;
      const newEdge = {
        id: edgeID,
        source: params.source,
        sourceHandle: params.sourceHandle,
        target: params.target,
        label: params.sourceHandle,
        type: params.type,
      };
      console.log("!!! NEW EDGE: ", newEdge);

      setEdges((eds) => [...eds, newEdge]);
    },
    []
  );

  const onEdgeContextMenu = useCallback((event, edge) => {
    event.preventDefault();
    console.log("!!! RIGHT CLICKED EDGE: ", edge);
    setEdges((eds) => eds.filter((e) => e.id !== edge.id));
  }, []);

  const deleteNodeById = useCallback((id) => {
    console.log("!!! DELETE NODE ID: ", id);
    setNodes((nds) => nds.filter((n) => n.id !== id));
    setEdges((eds) => eds.filter((e) => e.source !== id && e.target !== id));
  }, []);

  /*if (nodes.length === 0) {
    return <div>Loading...</div>;
  }*/



  return (
    <div style={{ display: "flex", flexDirection: "row", gap: "10px", height: "100%", width: "100%" }}>
      <div style={{ width: "200px" }}>
        {
          nodeTypeCards && Object.keys(nodeTypeCards).map((type) => {
            const CardComponent = nodeTypeCards[type];
            return (
              <CardComponent key={type} style={{ marginTop: "10px", marginBottom: "10px", cursor: "pointer" }} onAdd={() => {
                const newNode = {
                  id: `node-${nodes.length + 1}`,
                  position: { x: 250, y: 25 + nodes.length * 75 },
                  data: {
                    onDelete: deleteNodeById,
                    label: `${type} Node`
                  },
                  type: type,
                  deletable: true,
                };
                setNodes((nds) => nds.concat(newNode));
              }} />
            );
          })
        }
      </div>
      <div style={{ flexGrow: 1, border: "1px solid var(--main-border-color)", height: "100%" }}>
        <ReactFlow
          nodeTypes={nodeTypes}
          nodes={nodes}
          edges={edges}
          onNodesChange={onNodesChange}
          onNodesDelete={onNodesDelete}
          onEdgesChange={onEdgesChange}
          onEdgesDelete={(edges) => {
            console.log("!!! DELETE EDGES: ", edges);
            setEdges((eds) => eds.filter((e) => !edges.includes(e.id)));
          }}
          onEdgeContextMenu={onEdgeContextMenu}
          onConnect={onConnect}
        >
          <Background />
          <Controls />
        </ReactFlow>
      </div>
    </div >
  );
};

export default Workflow;

